import type { TabDesignType } from "../types";

export const getPlaceholders = ({
  length,
  itemsInRow,
  design,
}: {
  length: number;
  itemsInRow: number;
  design: TabDesignType;
}) => {
  const maxItems = Math.ceil(length / itemsInRow) * itemsInRow;
  let placeholdersCount = 0;
  if (["design-1", "design-2"].includes(design)) {
    placeholdersCount = Math.max(0, maxItems - length);
  }
  return { placeholdersCount, maxItems };
};
